import { post } from '../baseService'

const create = (): any => {
  const setExported = () =>
    post(`config-api/driverActiveness/markExported`, {}, false)

  return {
    setExported,
  }
}

export default {
  create,
}
